import type { ImageProps } from 'next/image';

import { getImageUrl } from './getImageUrl';

export const getImageDimensions = (src?: ImageProps['src']) => {
  const url = getImageUrl(src);

  if (!url) {
    return { width: undefined, height: undefined };
  }

  const width = Number(url.searchParams?.get('width')) || undefined;
  const height = Number(url.searchParams?.get('height')) || undefined;

  return { width, height };
};
